import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import {Cameras} from "./cameras/Cameras";
import {Charts} from "./charts/Charts";
import {get_birdhouse, get_filters} from "../api/routes";
import {useLoading} from "../loading-context/useLoading";

export const BirdhouseView = () => {
    const [params, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [details, setDetails] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [filters, setFilters] = useState([]);
    const [currentFilter, setCurrentFilter] = useState(undefined);

    useEffect(() => {
        if (!params.get("id")) navigate("/error-page");
    })

    useEffect(() => {
        if(currentFilter) return;
        fetch(get_filters).then(res => res.json()).then(data => {
            const arr = Object.values(data.measurement_filters_metadata);
            setFilters(arr);
            setCurrentFilter(arr[1]);
        }).catch();
    });

    useEffect(() => {
        if(!currentFilter) return;
        fetch(get_birdhouse(params.get("id"), currentFilter))
            .then(response => response.json())
            .then(data => {
                data.sensors.forEach(s => {
                    for (let i = 0; i < s.measurements.length; i++) {
                        const m = s.measurements[i];
                        m.timestamp_date = new Date(m.timestamp);
                        if (i === 0) continue;
                        if (m.timestamp_date - s.measurements[i - 1].timestamp_date < 60 * 1000 * 60) continue;

                        const newM = { ...m }
                        newM.median = null;
                        s.measurements = [
                            ...s.measurements.slice(0, i),
                            newM,
                            ...s.measurements.slice(i)
                        ];
                        i++;
                    }
                });
                setDetails(data);
            })
            .catch()
            .finally(() => setIsLoading(false));
    }, [params.get("id"), currentFilter]);

    useLoading(isLoading || !currentFilter);

    if (isLoading || !currentFilter) return null;

    if(!params.get("id") || !params.get("view")) {
        return <></>
    }

    return <>
        {params.get("view") === "cameras" && <Cameras details={details} />}
        {params.get("view") === "charts" && <Charts filters={filters}
                                                    details={details}
                                                    currentFilter={currentFilter}
                                                    setCurrentFilter={setCurrentFilter} />}
    </>
}